export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'
export const BOOTSTRAP_CURRENT_USER = 'BOOTSTRAP_CURRENT_USER'
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'
export const SET_CODE_PROMO_STATUS = 'SET_CODE_PROMO_STATUS'
export const LOAD_DISCOUNT_TYPES = 'LOAD_DISCOUNT_TYPES'
export const ADD_CODEPROMO = 'ADD_CODEPROMO'
export const ADD_CODEPROMOS = 'ADD_CODEPROMOS'

